export default {
    menus: {
        '/': 'home',
        m: 'home',
        homePage: 'HomePage',
        '/homePage': 'HomePage',
        userInfo: 'User Info',
        '/userInfo': 'User Info',
        userProducts: 'Products',
        userOrder: 'orders',
        userRetail: 'retails',
        userPassword: 'edit password',
        vips: 'VIP',
        reports: 'data report',
        Pedigree: 'Pedigree',
        PedigreeDetail: 'PedigreeDetail',
        Spectrums: 'Spectrums',
        Books: 'Books',
        BookDetails: 'BookDetails',
        BookConfigs: 'BookConfigs',
        PrintPreview: 'PrintPreview',
        Prints: 'Prints'
    },
    login: {
        title: 'user login',
        btnTitle: 'login',
        btnResetPwd: 'reset password',
        btnRegister: 'register'
    },
    dialog: {
        deleteTitle: 'Are you sure you want to delete the user '
    },
    table: {
        name: 'name',
        clanQuantity: 'clanQuantity',
        'create-time': 'createtime',
        'update-time': 'updatetime',
        action: 'action',
        logtitle: 'logtitle',
        logtype: 'logtype',
        clanname: 'clanname',
        clanmenber: 'clanmenber',
        devicetype: 'devicetype',
        device: 'device',
        content: 'content',
        ipaddress: 'ipaddress',
        book: 'book',
        priview: 'priview',
        standard: 'standard',
        highquality: 'highquality',
        print: 'print',
        wxshow: 'wxshow'
    },
    message: {
        updeteSuccess: 'update successfully',
        removeSuccess: 'remove successfully'
    },
    driver: {
        doneBtnText: 'done',
        closeBtnText: 'close',
        nextBtnText: 'next',
        prevBtnText: 'prev',
        guideBtn: 'guidebtn',
        hamburgerBtn: 'hamburgerBtn',
        fullScreen: 'fullScreen'
    }
}
